import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    assetNameInvalid: string;
    assetNameForbidden: string;
    assetNameReserved: ({ value }: {
        value: string;
    }) => string | React.ReactNode;
    assetNameDuplicate: string;
    assetNameLength: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error indicating that the asset name is invalid for a project stored in ESM */
            assetNameInvalid: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "hasEsmProjectError.assetNameInvalid?c=3smhlnc3807lg", defaultMessage: "Asset name cannot end with a space or period." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error indicating that the asset name is forbidden for a project stored in ESM */
            assetNameForbidden: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "hasEsmProjectError.assetNameForbidden?c=39updd1zdgy1l", defaultMessage: "Asset name cannot contain the following characters:  / * ? \" | : '<' '>'\"" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error indicating that the asset name is reserved for a project stored in ESM */
            assetNameReserved: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ value }: {
                        value: string;
                    }) => __intl__.intl().formatMessage({ id: "hasEsmProjectError.assetNameReserved?c=2lqbdgafns3md", defaultMessage: "Asset name cannot be a reserved name: {value}" }, { value: value }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error indicating that the asset name is duplicate for a project stored in ESM */
            assetNameDuplicate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "hasEsmProjectError.assetNameDuplicate?c=307qw72a6o0g9", defaultMessage: "The asset name is already in use. Please choose a different name." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error indicating that the asset name length is invalid for a project stored in ESM */
            assetNameLength: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "hasEsmProjectError.assetNameLength?c=24jl1raxvmlt7", defaultMessage: "Asset name must be between 1 and 255 characters long." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
